import { ModuleWithProviders } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

//Services
import { AuthGuardService } from '../../shared/services/auth-guard.service';
import { ReportsService } from './services/reports.service';
//Components
import { ReportsComponent } from './reports.component';
import { ResourceAllocationComponent } from './components/resource-allocation/resource-allocation.component';
import { ResourceAvailabilityComponent } from './components/resource-availability/resource-availability.component';
import { TimesheetComponent } from './components/timesheet/timesheet.component';

import { IncomeComponent } from './components/income/income.component';

export const reportsRoutes: Routes = [
    {
        path: 'reports',
        component: ReportsComponent,
        children: [
            {
                path: 'resourceallocation',
                component: ResourceAllocationComponent
            },
            {
                path: 'resourceavailability',
                component: ResourceAvailabilityComponent
            },
            {
                path: 'income',
                component: IncomeComponent
            },
            {
                path: 'timesheet',
                component: TimesheetComponent
            }
        ]
    }
];

export const reportsRoutingProviders: any[] = [
    ReportsService,
    DatePipe
];


// WEBPACK FOOTER //
// ./src/app/modules/reports/reports.route.ts